// THE REPORTS' TABS (UI rebuild batch 5 · Balance sheet and Trading): Astra's row under each report's head —
// Profit · Inventory · Balance sheet · Trading — one link per report, the lit one in the accent. The four come from
// lib/routes.ts (the More page's "Reports" section), so a name changes in one place.
import { moreRoutes } from '../../../lib/routes';
import { Tabs } from '../kit';

export function ReportTabs({ current }: { current: string }) {
  const items = moreRoutes('Reports').map((r) => ({ id: r.path, label: r.title, to: r.path }));
  return <Tabs label="Reports" current={current} items={items} />;
}
